import usePageable from '@/composables/filters/usePageable';
import {ref} from 'vue';

export default function () {
  const pageable = usePageable();
  pageable.sortField.value = 'name';

  const filters = ref({
    name: {value: null},
    stakeholderId: {value: null},
    locked: {value: null},
  });

  function getQueryParams() {
    const params = pageable.getQueryParams();

    if (filters.value.name?.value) {
      params['name'] = filters.value.name.value;
    }

    if (filters.value.stakeholderId?.value) {
      params['stakeholderId'] = filters.value.stakeholderId.value;
    }

    if (filters.value.locked?.value != null) {
      params['locked'] = filters.value.locked.value;
    }

    return params;
  }

  return {
    pageable,
    filters,
    getQueryParams,
  }
}


